import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import fetchRoute from "utils/routes";
import ListSubscription from "assets/js/scenes/publicHash/scenes/listRedirections/containers/ListSubscription";
import ListUnsubscribe from "assets/js/scenes/publicHash/scenes/listRedirections/containers/ListUnsubscribe";
import ListUnsubscribeForm from "assets/js/scenes/publicHash/scenes/listRedirections/containers/ListUnsubscribeForm";
import ListRedirectionParamLoader from "assets/js/scenes/publicHash/scenes/listRedirections/components/ListRedirectionParamLoader";
import { Modal } from "cakemail-ui-components/lib/react";
import ListGlobalUnsubscribeForm from "assets/js/scenes/publicHash/scenes/listRedirections/containers/ListGlobalUnsubscribeForm";
const PublicHash = (props) => {
	return (
		<Modal className="listRedirectionPages">
			<Switch>
				<Route
					path={fetchRoute("listSubscription")}
					render={() => (
						<ListRedirectionParamLoader>
							<ListSubscription />
						</ListRedirectionParamLoader>
					)}
				/>
				<Route
					path={fetchRoute("listConfirmation")}
					render={() => (
						<ListRedirectionParamLoader>
							<ListSubscription />
						</ListRedirectionParamLoader>
					)}
				/>
				<Route
					path={fetchRoute("listUnsubscribe")}
					render={() => (
						<ListRedirectionParamLoader>
							<ListUnsubscribe />
						</ListRedirectionParamLoader>
					)}
				/>
				<Route
					path={fetchRoute("listUnsubscribeAll")}
					render={() => (
						<ListRedirectionParamLoader>
							<ListUnsubscribe fromAll />
						</ListRedirectionParamLoader>
					)}
				/>
				<Route
					path={fetchRoute("listUnsubscribeForm")}
					render={() => (
						<ListRedirectionParamLoader>
							<ListUnsubscribeForm />
						</ListRedirectionParamLoader>
					)}
				/>
				<Route
					path={fetchRoute("listGlobalSubscription")}
					render={() => (
						<ListRedirectionParamLoader>
							<ListGlobalUnsubscribeForm />
						</ListRedirectionParamLoader>
					)}
				/>
				<Redirect to={fetchRoute("signIn")} />
			</Switch>
		</Modal>
	);
};

PublicHash.propTypes = {};

export default PublicHash;
